import { render, staticRenderFns } from "./StoryImage.vue?vue&type=template&id=0aa6e991&"
import script from "./StoryImage.vue?vue&type=script&lang=js&"
export * from "./StoryImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports